import React from "react";
import { FormDefinitionValidateResponse } from "interfaces/Phoenix.FormsDesigner.Models";

interface Props {
  validationResult: FormDefinitionValidateResponse;
};

const ValidationMessages = ({ validationResult }: Props) => {

  return (
    <div className="phoenix-validation-messages">
      {validationResult.messageGroups.map(g => <>
        <div className="validation-title">{g.title} - {g.failed ? "Failed" : "Passed"}</div>
        {g.messages.map(m => <div className="validation-message">{m}</div>)}
      </>)}
    </div>
  );
}

export default ValidationMessages;
